export default (
	formSpreeEndpoint: string,
	data: Record<string, string>
): Promise<unknown> => {
	if (import.meta.client && process.env.NODE_ENV !== 'production') {
		console.warn('not submitted:', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
			body: JSON.stringify(data),
		});

		return Promise.resolve();
	}

	return $fetch(formSpreeEndpoint, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
		},
		body: JSON.stringify(data),
	});
};

export const formspreeFormSubmitByFormData = (
	formSpreeEndpoint: string,
	formData: FormData,
	additionalValues: Record<string, string> = {},
	defaultValues: Record<string, string> = {}
): Promise<unknown> => {
	for (const [key, value] of Object.entries(additionalValues)) {
		formData.append(key, value);
	}

	for (const [key, value] of Object.entries(defaultValues)) {
		if (!formData.has(key)) {
			formData.append(key, value);
		}
	}

	if (import.meta.client && process.env.NODE_ENV !== 'production') {
		console.warn('not submitted:', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
			body: formData,
		});

		return Promise.resolve();
	}

	return $fetch(formSpreeEndpoint, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
		},
		body: formData,
	});
};
